if (!customElements.get('td-accordion-card')) {
  class TdAccordionCard extends HTMLElement {
  
    constructor() {
      super();
      this.ACCORDION_TRIGGER = this.querySelector('[data-accordion-trigger]');
      this.ACCORDION_CONTENT = this.querySelector('[data-accordion-content]');
      this.ACTIVE_CLASS = 'td-active';
      this.isExpanded = this.classList.contains(this.ACTIVE_CLASS);
      
      this.boundToggleAccordion = this.toggleAccordion.bind(this);
    }
    
    connectedCallback() {
      if (!this.ACCORDION_CONTENT && !this.ACCORDION_TRIGGER) {
        return;
      }
      this.attachListeners();
    }
    
    attachListeners() {
      this.ACCORDION_TRIGGER.addEventListener('click', this.boundToggleAccordion);
    }
    
    disconnectedCallback() {
      if (this.ACCORDION_TRIGGER) {
        this.ACCORDION_TRIGGER.removeEventListener('click', this.boundToggleAccordion);
      }
    }

    open(dropdown) {
      dropdown.classList.add(this.ACTIVE_CLASS);
    }

    close(dropdown) {
      dropdown.classList.remove(this.ACTIVE_CLASS);
    }

    toggleAccordion() {
      this.classList.contains(this.ACTIVE_CLASS)
        ? this.close(this)
        : this.open(this);
    }
    
  }
  customElements.define('td-accordion-card', TdAccordionCard);
}
